webpackJsonp(["module.loader"],{

/***/ "/opt/atlassian/pipelines/agent/build/node_modules/babel-loader/lib/index.js??ref--23-0!/opt/atlassian/pipelines/agent/build/node_modules/eslint-loader/index.js!/opt/atlassian/pipelines/agent/build/client/src/scripts/module.loader.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _console = console,
    log = _console.log;


var ZERO = 0;
var ONE = 1;
var FIFTY = 50;
var STYLESHEET_CHECK_TIMEOUT = FIFTY;
var MINUS_ONE = -1;

var AmdModuleLoader = function () {
    function AmdModuleLoader() {
        _classCallCheck(this, AmdModuleLoader);

        this.listeners = {};
        this.resolves = {};
        this.options = {
            baseUrl: ''
        };
    }

    _createClass(AmdModuleLoader, [{
        key: 'config',
        value: function config(properties) {
            var _this = this;

            Object.keys(properties).forEach(function (property) {
                _this.options[property] = properties[property];
            });
        }
    }, {
        key: 'addLoadListener',
        value: function addLoadListener(listener, name) {
            log('addLoadListener', name);
            if (Object.keys(this.resolves).includes(name)) {
                // value is already loaded, call listener immediately
                listener(name, this.resolves[name]);
            } else if (this.listeners[name]) {
                this.listeners[name].push(listener);
            } else {
                this.listeners[name] = [listener];
                // first time this dependency is requested
                // get the loader name from string before ! character
                this.require(['js!' + name.split('!')[0]], function (loader) {
                    loader(name);
                });
            }
        }
    }, {
        key: 'resolve',
        value: function resolve(name, value) {
            log('resolve', name);
            this.resolves[name] = value;
            var libListeners = this.listeners[name];
            if (libListeners) {
                libListeners.forEach(function (listener) {
                    listener(name, value);
                });
                // remove listeners (delete listeners[name] is longer)
                this.listeners[name] = ZERO;
            }
        }
    }, {
        key: 'require',
        value: function require(deps, definition) {
            log('require', deps);
            var length = deps.length;
            if (length) {
                if (typeof deps === 'string') {
                    deps = deps.split(' ');
                }
                // we need to wait for all dependencies to load
                var values = [];
                var loaded = ZERO;

                deps.forEach(this.addLoadListener.bind(this, function (name, value) {
                    values[deps.indexOf(name)] = value;
                    loaded = loaded + ONE;

                    if (loaded += ONE >= length) {
                        definition.apply(definition, values);
                    }
                }));
            } else {
                // no dependencies, run definition now
                definition();
            }
        }
    }, {
        key: 'define',
        value: function define(name, deps, definition) {
            var _this2 = this;

            log('define', name);
            if (definition) {
                // asynchronous define with dependencies
                this.require(deps, function () {
                    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key];
                    }

                    _this2.resolve(name, definition.apply(definition, args));
                });
            } else {
                // just two arguments - bind name to value (deps) now
                this.resolve(name, deps);
            }
        }
    }, {
        key: 'addElement',
        value: function addElement(name, properties) {
            log('addElement', name);
            var element = document.createElement(name);
            Object.keys(properties).forEach(function (property) {
                element[property] = properties[property];
            });
            document.head.appendChild(element);
        }
    }]);

    return AmdModuleLoader;
}();

var Loader = window.Loader = global.Loader = new AmdModuleLoader();
var RemoteUrlPattern = /(http\:)?\/\//;

Loader.define('js!js', function (name) {
    log('jsPlugin', name);
    var fileName = name.split('!')[ONE];
    if (!fileName.match(RemoteUrlPattern)) {
        fileName = '' + Loader.options.baseUrl + fileName;
        log('jsPlugin.isLocal', fileName);
    }
    Loader.addElement('SCRIPT', {
        src: fileName
    });
});

Loader.define('js!css', function (name) {
    log('cssPlugin', name);
    var fileName = name.split('!')[ONE];
    function check() {
        document.styleSheets.forEach(function (sheet) {
            if (sheet.href && sheet.href.indexOf(fileName) > MINUS_ONE) {
                return Loader.define(name);
            }

            return name;
        });
        // style is loaded but not being applied yet
        setTimeout(check, STYLESHEET_CHECK_TIMEOUT);
    }
    Loader.addElement('LINK', {
        href: fileName,
        rel: 'stylesheet',
        onload: check
    });
});

window.Loader = Loader;

var toLoad = document.body.getAttribute('data-load');
if (toLoad && toLoad.length > ZERO) {
    log('initBodyLoad', name);
    // require dependencies specified in <body data-load attribute
    setTimeout(Loader.require.bind(Loader, toLoad.split(' '), Date), ZERO);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/opt/atlassian/pipelines/agent/build/node_modules/babel-loader/lib/index.js??ref--23-0!/opt/atlassian/pipelines/agent/build/node_modules/eslint-loader/index.js!/opt/atlassian/pipelines/agent/build/node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "/opt/atlassian/pipelines/agent/build/node_modules/babel-loader/lib/index.js??ref--23-0!/opt/atlassian/pipelines/agent/build/node_modules/eslint-loader/index.js!/opt/atlassian/pipelines/agent/build/node_modules/webpack/buildin/global.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),

/***/ "multi /opt/atlassian/pipelines/agent/build/client/src/scripts/module.loader.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("/opt/atlassian/pipelines/agent/build/node_modules/babel-loader/lib/index.js??ref--23-0!/opt/atlassian/pipelines/agent/build/node_modules/eslint-loader/index.js!/opt/atlassian/pipelines/agent/build/client/src/scripts/module.loader.js");


/***/ })

},["multi /opt/atlassian/pipelines/agent/build/client/src/scripts/module.loader.js"]);


// WEBPACK FOOTER //
// scripts/module.loader--0df774006d2e890672b0.js